import React from 'react';
import { Table, Button } from '../common';
import PortOpeningRequestSiteToSiteOnPrem from '../../models/entities/PortOpeningRequestSiteToSiteOnPrem';
import ProgressBarSmall from '../OnPremSiteToSiteVPNRequests/components/ProgressBarSmall';
import { useNavigate } from 'react-router-dom';
import './ApprovalsPORsTableRow.css';

interface ApprovalsS2SPORsTableRowProps {
    por: PortOpeningRequestSiteToSiteOnPrem;
}

const ApprovalsS2SPORsTableRow = ({ por }: ApprovalsS2SPORsTableRowProps) => {
    const navigate = useNavigate();
    
    const handleViewDetails = () => {
        navigate(`/OnPremSiteToSiteVPNRequests/${por.id}`);
    };
    
    return (
        <Table.Row>
            <Table.Cell>
                #{por.id}
            </Table.Cell>
            <Table.Cell className='em-u-text-align-center center-align'>
                <ProgressBarSmall workflowState={(por as any).onPremWorkflowInstance.currentWorkflowInstanceState.onPremWorkflowState} />
            </Table.Cell>
            <Table.Cell className='em-u-text-align-center'>
                <Button style={{ width: 120, height: 34 }} onClick={handleViewDetails} variant="primary">
                    See Details
                </Button>
            </Table.Cell>
        </Table.Row>
    );
}

export default ApprovalsS2SPORsTableRow;
